/** @param {string} id */
export function showWarningMessage(id) {
  document.getElementById(id)?.style.setProperty('display', 'block');
}

/** @param {string} id */
export function hideWarningMessage(id) {
  document.getElementById(id)?.style.setProperty('display', 'none');
}

// Global access
Object.assign(window, {
  showWarningMessage,
  hideWarningMessage,
});

// Global handlers for campus change confirmation (called by warning-message component)
window.handleCampusChangeAccept = function (warningId) {
  if (window.courseMaterialsSidebar) {
    window.courseMaterialsSidebar.handleCampusChangeAccept(warningId);
  }
};

window.handleCampusChangeCancel = function (warningId) {
  if (window.courseMaterialsSidebar) {
    window.courseMaterialsSidebar.handleCampusChangeCancel(warningId);
  }
};
